<template>
  <div class="dis-connect d-flex">
    <div class="d-flex dis-button mt-2">
      <ms-split-button
        :menuItems="menuItems"
        text="Thêm chứng từ"
        @menuClick="clickMenu"
        class="btn-guide circle-button mr-1"
        classCustom="circle-button"
      >
      </ms-split-button>
      <ms-button text="Xem danh sách chứng từ" class="list-voucher" @click="offlineVoucherList" />
    </div>

    <div>Hoặc tiếp tục làm việc ngoại tuyến.</div>
    <div>Không có kết nối Internet. Vui lòng kiểm tra mạng.</div>
    <div class="dis-title mt-2">Kết nối Internet</div>
    <div class="no-error text-center">
      <img src="@/assets/images/connect/Disconect.svg" class="img-bg" />
    </div>
  </div>
</template>

<script>
import {reactive, ref, getCurrentInstance, defineComponent, onMounted, computed} from 'vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import popupUtil from '@/commons/popupUtil';
export default defineComponent({
  name: 'DefaultTabOffline',
  setup() {
    const {proxy} = getCurrentInstance();
    const menuItems = ref([
      // {
      //   text: 'Rút dự toán tiền mặt',
      //   command: 'Cash',
      // },
      // {
      //   text: 'Rút dự toán tiền gửi',
      //   command: 'Deposit',
      // },
      {
        text: 'Chuyển khoản kho bạc vào TK tiền gửi',
        command: 'TransferDetail',
      },
      // {
      //   text: 'Chi tiền gửi',
      //   command: 'BAWithDrawDetail',
      // },
      // {
      //   text: 'Phiếu thu',
      //   command: 'CAReceiptDetail',
      // },
      // {
      //   text: 'Phiếu chi',
      //   command: 'CAPaymentDetail',
      // },
      // {
      //   text: 'Chứng từ nghiệp vụ khác',
      //   command: 'Voucher',
      // },
    ]);

    const clickMenu = async item => {
      switch (item.command) {
        case 'Cash':
          popupUtil.show('BUPlanWithdrawCashDetail', {
            mode: proxy.$ms.constant.FormState.Add,
            formApproveName: 'ApproveVoucherBUPlanWithdrawTab',
            ref_type: 54,
            offlineReady: true,
          });
          break;
        case 'Deposit':
          popupUtil.show('BUPlanWithdrawDepositDetail', {
            mode: proxy.$ms.constant.FormState.Add,
            formApproveName: 'ApproveVoucherBUPlanWithdrawTab',
            ref_type: 562,
            offlineReady: true,
          });
          break;
        case 'TransferDetail':
          popupUtil.show('BUTransferDepositDetail', {
            mode: proxy.$ms.constant.FormState.Add,
            formApproveName: 'ApproveVoucherBUTransferTab',
            ref_type: 561,
            offlineReady: true,
          });
          break;
        case 'BAWithDrawDetail':
          popupUtil.show('BAWithDrawDetail', {
            mode: proxy.$ms.constant.FormState.Add,
            formApproveName: 'ApproveVoucherBAWithDrawTab',
            ref_type: 157,
            offlineReady: true,
          });
          break;
        case 'CAReceiptDetail':
          popupUtil.show('CAReceiptDetail', {
            mode: proxy.$ms.constant.FormState.Add,
            formApproveName: 'ApproveVoucherCAReceiptList',
            ref_type: 101,
            offlineReady: true,
          });
          break;
        case 'CAPaymentDetail':
          popupUtil.show('CAPaymentDetail', {
            mode: proxy.$ms.constant.FormState.Add,
            formApproveName: 'ApproveVoucherCAPayment',
            ref_type: 106,
            offlineReady: true,
          });
          break;
        case 'Voucher':
          popupUtil.show('GLGeneralVoucherDetail', {
            mode: proxy.$ms.constant.FormState.Add,
            formApproveName: 'ApproveVoucherGLVoucherTab',
            ref_type: 401,
            offlineReady: true,
          });
          break;
        default:
          break;
      }
    };

    function offlineVoucherList() {
      popupUtil.show('ListVoucherOffline');
    }
    return {menuItems, clickMenu, offlineVoucherList};
  },
});
</script>
<style lang="scss">
.dis-connect {
  height: 100%;
  background-color: #f4f5f8;
  text-align: center;
  top: 0;
  left: 50%;
  justify-content: center;
  flex-direction: column-reverse;
  .dis-button {
    align-items: center;
    justify-content: center;
  }
  .list-voucher {
    border-radius: 16px;
    border: 1px solid black !important;
    background: #f4f5f8 !important;
    color: black !important;
    &.primary:hover {
      background: $button-secondary-active-bg !important;
    }
  }
  .dis-title {
    font-size: 18px;
    font-weight: $font-weight-bold;
  }
}
</style>
